// removed by extract-text-webpack-plugin
module.exports = {"projectCell":"DO_T7Z9ze1RJaHcqfPATy","imageSection":"_3k3t1afiZSS4NhF-98aV0f","image":"_1EjzDCjg4NrObiwG0V_hW1","price":"_3uj0XYeuuA-MU5f7sjAH9f","descriptionSection":"plntrcNXd5miolwbPLAzo","name":"_3OR6wWDNIBLZMUw-R8N_f9","propertyType":"_2suuyPu1D-y2ZP3OOwJlrp","summary":"wZ_1s2fLVLGCUGEa-6UzA","status":"_2fqOCWWBh47f2nHvHwjbgf","projectInfo":"GvEg4Hw8rAPeRukvi9Eua","logoProjectWrapper":"DxKt0x75Enc20u6dTkHnC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectCell/ProjectCell.scss
// module id = 1693
// module chunks = 0